const routerArr = [
  {
      path: '/scourse',
      name: 'scourse',
      meta: { title:'学习' ,login:true},
      component: () => import(/* webpackChunkName: 'course' */ './page/index.vue'),
  },
  {
    path: '/cxu',
    name: 'cxu',
    meta: { title:'学习',login:false },
    component: () => import(/* webpackChunkName: 'course' */ './page/cxu.vue'),
},
  {
      path: '/showPdf',
      name: 'showPdf',
      meta: { title:'学习',login:false },
      component: () => import(/* webpackChunkName: 'course' */ './page/showPdf.vue'),
  },
  // {
  //   path: '/showPdf',
  //   name: 'showPdf',
  //   meta: { title:'学习',login:true },
  //   component: () => import(/* webpackChunkName: 'course' */ './page/showPdf.vue'),
  // },
  {
    path: '/homeworkDetail',
    name: 'homeworkDetail',
    meta: { title:'作业',login:true },
    component: () => import(/* webpackChunkName: 'course' */ './page/homeworkDetail.vue'),
  },
  {
    path: '/hwResourcePreview',
    name: 'hwResourcePreview',
    meta: { title:'预览',login:true },
    component: () => import(/* webpackChunkName: 'course' */ './page/hwResourcePreview.vue'),
  },
  {
    path: '/homeworkList',
    name: 'homeworkList',
    meta: { title:'作业',login:true },
    component: () => import(/* webpackChunkName: 'course' */ './page/components/homeworkList.vue'),
  },
  
  
]
export default routerArr


